<template lang="pug">
    left-panel-layout.profile-left-panel(v-bind="$attrs" :menu="menu" ref="modal")
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'profile-left-panel',

    computed: {
        ...mapGetters(['authUser']),

        menu() {
            const menu = [
                { name: 'My Profile', route: {name: 'settings-profile-page'} },
            ]

            if (this.gmhReady) {
                menu.push({ name: 'Account Management', route: {name: 'settings-account-management'} })
            }

            if (this.authUser.creator) {
                menu.push({ name: 'Store', route: {name: 'settings-store-page'} })
                menu.push({ name: 'Media Vault', route: {name: 'settings-media-vault-page'} })
            }

            if (this.gmhReady) {
                menu.push({ name: 'Earning Dashboard', route: {name: 'settings-earning-dashboard-page'} })
                menu.push({ name: 'Purchases', route: {name: 'settings-purchased-page'} })
                menu.push({ name: 'Become a Creator', route: {name: 'settings-become-creator-page'} })
            }

            menu.push({ name: 'Log Out', click: this.logout })

            return menu
        },

        gmhReady() {
            return this.authUser.meta.gmh_ready
        },
    },

    methods: {
        logout() {
            this.$store.dispatch('logout')
            this.$router.push({ name: 'login-page' })
        },
    },
}
</script>
